// extracted by mini-css-extract-plugin
export default {"face":"FaceEmoji_face__8y3Tl"};